import { TableFilterType } from 'features/TableFilter';
import { getFilterServerFormatDate } from 'shared/utils/helpers/getDateFormat';
import { ArrivalStatisticsQueryParams } from 'entities/Warehouse';
import { UserAccountType } from 'entities/User';

export const transformArrivalsStatisticsFilters = ({
  selectedWarehouses,
  isApplicable,
  startDate,
  endDate,
  accountType,
}: TableFilterType): ArrivalStatisticsQueryParams => {
  const warehouseId = selectedWarehouses?.value?.length ? selectedWarehouses.value : undefined;

  return {
    warehouseId,
    isApplicable: isApplicable?.value === undefined ? undefined : isApplicable?.value === 'applicable',
    startDate: getFilterServerFormatDate(startDate?.value),
    endDate: getFilterServerFormatDate(endDate?.value),
    accountType: accountType?.value ? (accountType.value as UserAccountType) : undefined,
  };
};
